import { Component, OnInit } from "@angular/core";
import { SubscriptionListService } from "./subscription-list.service";
import { NgxSpinnerService } from "ngx-spinner";
import { ToastrService } from "ngx-toastr";
@Component({
  selector: "app-subscription-list",
  templateUrl: "./subscription-list.component.html",
  styleUrls: ["./subscription-list.component.sass"],
})
export class SubscriptionListComponent implements OnInit {
  constructor(
    private toastr: ToastrService,
    private spinner: NgxSpinnerService,
    private subscriptionListService: SubscriptionListService
  ) {}

  selectedPlan: any = null;
  showModal = false;


  ngOnInit(): void {
    this.getPlans(1, 1);
  }

  allPlanList: any[] = [];
  itemsPerPage: number = 6;
  totalItems: number = 0;
  page: number = 1;
  activePlanType: number = 1; // 1 = upto 4 ton, 2 = 4+ ton, 3 = topup

  getPlans(planType: number, page: number) {
    this.spinner.show()
    this.activePlanType = planType;
    this.page = page;

    let data = {
      planType: planType,
      limit: this.itemsPerPage,
      page: page,
    };

    this.subscriptionListService
      .getSubscritionPlans(data)
      .subscribe((result: any) => {
        if (result.statusCode == 200) {
          this.allPlanList = result.data;
          this.spinner.hide();
          this.totalItems = result.pagination?.total || 0;
        } else {
          this.spinner.hide();
          this.toastr.error(result.message);
        }
      });
  }

  openAddPlan() {
    this.selectedPlan = null;
    this.showModal = true;
  }

  openEditPlan(plan: any) {
    this.selectedPlan = { ...plan };
    console.log("plan", plan);
    this.showModal = true;
  }

  handleCloseModal() {
    this.showModal = false;
  }

  handleSave(plan: any) {
    console.log("plan", plan);
    this.getPlans(plan, 1);
    this.handleCloseModal();
  }

  deleteSubscription(plan) {
    let id=plan._id
    let planType=plan.planType
    console.log("plan", plan)
    this.spinner.show();
    this.subscriptionListService.deletePlan(id).subscribe((result: any) => {
      if (result.statusCode == 200) {
        this.toastr.success(result.message);
        this.spinner.hide();
        this.getPlans(planType, 1);
      } else {
        this.spinner.hide();
        this.toastr.error(result.message);
      }
    });
  }
}
